import React from "react";
import { InfoVert } from "../";
import { scoreFactors } from "_helpers/experian";
import "./Score.scss";

function Score(props) {
  // TransUnion data doesn't include score in the provided JSON structure
  // Score data would typically be in a separate section if available
  const score = null; // No score data in current TransUnion format

  return (
    <div id={props.id} className="wzrd-box score">
      <div className="wzrd-header">
        <h3>Score Summary</h3>
      </div>
      <div className="wzrd-body">
        <div className="columns" style={{ marginBottom: "24px" }}>
          <InfoVert title="Risk Model">TransUnion Credit Report</InfoVert>
          {score?.score ? (
            <InfoVert title="Score">{parseInt(score?.score)}</InfoVert>
          ) : (
            <InfoVert title="Score">Not Available</InfoVert>
          )}
        </div>
        {score?.reasons && score.reasons.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Score Factor Description</th>
              </tr>
            </thead>
            <tbody>
              {score?.reasons?.map((s, i) => (
                <tr key={`sf-${i}`}>
                  <td>{parseInt(s.code)}</td>
                  <td>{scoreFactors[parseInt(s.code)]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Score;
